import React from 'react';
import './HandicapAdjustmentConfirmationModal.css';

const HandicapAdjustmentConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  players,
  roundPlayersData // This will contain player_id, name, stableford_score, current_handicap_index, proposed_new_handicap
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Handicap Adjustments</h2>
        </div>
        <div className="modal-body">
          <p>Do you want to apply the following handicap adjustments?</p>
          <table className="handicap-adjustment-table">
            <thead>
              <tr>
                <th>Player</th>
                <th>Current H'cap</th>
                <th>Round Points</th>
                <th>Proposed New H'cap</th>
              </tr>
            </thead>
            <tbody>
              {roundPlayersData.map(data => (
                <tr key={data.player_id}>
                  <td>{data.name}</td>
                  <td>{data.previous_handicap_index?.toFixed(1) ?? 'N/A'}</td>
                  <td>{data.stableford_score ?? 'N/A'}</td>
                  <td>{data.new_handicap_index?.toFixed(1) ?? 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal-footer">
          <button onClick={onCancel} className="cancel-button">No, Just Finalize</button>
          <button onClick={onConfirm} className="save-button">Yes, Apply Adjustments</button>
        </div>
      </div>
    </div>
  );
};

export default HandicapAdjustmentConfirmationModal;
